// import
import { OpenStreetMapProvider } from 'leaflet-geosearch';

// setup
const provider = new OpenStreetMapProvider();

var _eQuatorialEarthRadius = 6378.1370;
var _d2r = (Math.PI / 180.0);


export interface Dist {
    distance: number,
    lat: number,
    lng: number,
}

/**
 * Funkcja oblicza odległość w metrach pomiędzy restauracją, a adresem klienta
 * @param address adres klienta
 * @param gps gps restauracji
 */
export async function distance(address: string, gps: string): Promise<Dist> {
    let distance: number = 0

    let gpsReturn = gpsToNumber(gps);
    let latRestaurant = gpsReturn.lat;
    let lngRestaurant = gpsReturn.lng;

    try {
        const results = await provider.search({ query: address });

        if (results.length > 0) {
            //współrzędne klienta
            let latClient = Number(results[0].raw.lat)
            let lngClient = Number(results[0].raw.lon)

            distance = Math.round(HaversineInM(latRestaurant, lngRestaurant, latClient, lngClient))
            return { distance: distance, lat: latClient, lng: lngClient }
        }

    } catch (error) {
        console.error(error);
    }

    return { distance: 0, lat: 0, lng: 0 }
}

export function gpsToNumber(gps: string): { lat: number, lng: number } {
    const wspolrzedne = gps.split(' ');
    let latNumber = 0
    let lngNumber = 0

    if (wspolrzedne.length === 2) {
        let lat = wspolrzedne[0].includes('N') || wspolrzedne[0].includes('S') ? wspolrzedne[0] : wspolrzedne[1];
        let lng = wspolrzedne[1].includes('E') || wspolrzedne[1].includes('W') ? wspolrzedne[1] : wspolrzedne[0];
        lat = lat.substring(0, lat.length - (lat.includes(',') ? 2 : 1));
        lng = lng.substring(0, lng.length - (lng.includes(',') ? 2 : 1));
        latNumber = Number(lat);
        lngNumber = Number(lng);
    }
    else {
        latNumber = 50.05394;
        lngNumber = 19.93560;
    }

    return { lat: latNumber, lng: lngNumber }
}

/**
 * Funkcja oblicza odległość między dwoma punktami na mapie w metrach - Haversine Algorithm
 */
export function HaversineInM(lat1: number, long1: number, lat2: number, long2: number) {
    return (1000.0 * HaversineInKM(lat1, long1, lat2, long2));
}

/**
 * Funkcja oblicza odległość między dwoma punktami na mapie w kilometrach - Haversine Algorithm
 */
function HaversineInKM(lat1: number, long1: number, lat2: number, long2: number) {
    var dlong = (long2 - long1) * _d2r;
    var dlat = (lat2 - lat1) * _d2r;
    var a = Math.pow(Math.sin(dlat / 2.0), 2.0) + Math.cos(lat1 * _d2r) * Math.cos(lat2 * _d2r) * Math.pow(Math.sin(dlong / 2.0), 2.0);
    var c = 2.0 * Math.atan2(Math.sqrt(a), Math.sqrt(1.0 - a));
    var d = _eQuatorialEarthRadius * c;

    return d;
}
